import axios from 'axios'

const service = axios.create({
  // 基础路径
  baseURL: 'http://www.fjlszy.com:8181/website',//正式环境
  // baseURL: 'http://192.168.181.68:8181/website',//测试环境
  // 请求不能超过10S
  timeout: 10000
});

//请求拦截器
service.interceptors.request.use((config) => {
  // 在项目中发请求（请求没有发出去）可以做一些事情
  return config;
});

//响应拦截器
service.interceptors.response.use(
  (res) => {
    // 当服务器手动请求之后，做出响应（相应成功）会执行的
    return res.data;
  },
  (err) => {
    alert("服务器响应数据失败");
  }
);

// 暴露service
export default service;



// WEBPACK FOOTER //
// ./src/api/request.js